import { useMutation } from 'react-query'
import type { AxiosError, AxiosInstance } from 'axios'
import { routes } from './constants'
import { axiosInstance } from './axiosConfig'

export interface OptOutSubmitRequest {
  physicianId: string
  email: string
}

export type OptOutSubmitApiError = AxiosError<{ message?: string }>

const submitOptOut = async (
  payload: OptOutSubmitRequest,
  instance: AxiosInstance
): Promise<void> => {
  await instance.post(routes.physicianOptOut(payload.physicianId), {
    email: payload.email,
  })
}

export interface useOptOutSubmitProps {
  onSuccess?: () => void
  onError?: (error: OptOutSubmitApiError) => void
  axios?: AxiosInstance
}

export const useOptOutSubmit = ({
  onSuccess,
  onError,
  axios = axiosInstance,
}: useOptOutSubmitProps = {}) => {
  const mutation = useMutation<void, OptOutSubmitApiError, OptOutSubmitRequest>(
    (payload) => submitOptOut(payload, axios),
    {
      onSuccess: () => onSuccess?.(),
      onError: (error) => onError?.(error),
    }
  )

  return {
    submitOptOutAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    isSuccess: mutation.isSuccess,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  }
}
